/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, October 20th 2021, 12:57:03 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { Outlet } from "react-router-dom";
import { Box } from "ui-widgets";

export const AuthBaseLayoutCentered = () => {
  return (
    <Box className="auth-base-file-2 auth-page-container" display="flex" justifyContent="center" alignItems="center">
      <Box className="auth-wrapper-out">
        {/* Outlet is new in react-router v6 that allows nested route components to be placed here. So we have a parent route for all routes that will use the AuthBaseLayout. */}
        <Outlet />
      </Box>
    </Box>
  );
};
